module.exports = __webpack_public_path__ + "static/media/break.40233b99.PNG";